import type { Result } from '@avalara/types/index';

import conf from '../../conf';
import { getContact } from '../../reducers/aggregate-logic';
import { getOrderSubtotal } from '../../selectors/order';
import { fetchingOrderSalesTax, receiveOrderSalesTax } from '../../store/order';
import fetch from '../fetch';
import { getSalesTax } from './avatax';

import type { Dispatch } from '@avalara/types/actions';
import type { State } from '@avalara/types/reducer-states';
import type { CreateTransactionResponse } from '../../../../types';

export const getOrderSalesTax = () => async (dispatch: Dispatch, getState: () => State) => {
  const state = getState();
  const {
    offer: { offerFlow, taxCode },
    system: { activeFlow },
    esb: { esbPartner },
  } = state;

  const contact = getContact(state);

  if (contact == null || contact === 'ERROR') {
    dispatch(receiveOrderSalesTax(null));
    return;
  }

  const subtotal = getOrderSubtotal(state);
  if (subtotal === 0) {
    dispatch(receiveOrderSalesTax(0));
    return;
  }

  if (activeFlow === 'esb-trial' && esbPartner === 'big-commerce') {
    dispatch(fetchingOrderSalesTax(true));
    const body = {
      items: [
        {
          amount: subtotal,
          taxCode: 'SW052000',
          id: 'esb-trial-big-commerce-partner',
        },
      ],
      contact,
    };
    const result = await getSalesTax(body, dispatch);
    dispatch(fetchingOrderSalesTax(false));
    if (result.ok) {
      dispatch(receiveOrderSalesTax(result.value.totalTaxCalculated));
      return;
    }
    dispatch(receiveOrderSalesTax(null));
    return;
  }

  if (!taxCode) {
    dispatch(receiveOrderSalesTax(null));
    return;
  }

  const items = [
    {
      id: offerFlow,
      amount: subtotal,
      taxCode,
    },
  ];

  const body = { contact, items };
  const postParams = {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  };

  dispatch(fetchingOrderSalesTax(true));

  const result: Result<CreateTransactionResponse> = await fetch(dispatch, { showLoadingWheel: false })(
    `${conf.API_URL}/api/offers/salestax`,
    postParams,
  );

  if (result.ok) {
    const salesTax = result.value.totalTaxCalculated;
    dispatch(receiveOrderSalesTax(salesTax));
  } else {
    dispatch(receiveOrderSalesTax(null));
  }
  dispatch(fetchingOrderSalesTax(false));
};
